var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stitle-wrapper"},[_c('span',{staticClass:"yellow-line"}),_c('span',{staticClass:"title-content"},[_vm._t("default")],2),(_vm.mode)?_c('span',{class:`title-icon icon-${_vm.mode}`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }